export default () => ({
  endpoint: '',
  testReports: {},
  selectedSuite: {},
  isLoading: false,
});
